
export const errors = {
  'error': 'Fel',
  'error.title': 'Fel',
  'error.invalid.credentials': 'Ogiltiga inloggningsuppgifter',
  'error.signin': 'Inloggningsfel',
  'error.signout': 'Utloggningsfel',
  'error.generic': 'Ett oväntat fel inträffade',
  'error.missing.email': 'E-post krävs',
  'error.invalid.recovery.link': 'Ogiltig återställningslänk',
  'error.password.requirements': 'Lösenordet uppfyller inte kraven',
  'error.password.update': 'Det gick inte att uppdatera lösenordet',
  'error.authentication': 'Autentiseringsfel',
  'error.permission': 'Åtkomst nekad',
  'error.update.preferences': 'Det gick inte att uppdatera inställningarna',
  'errors.invalid.credentials': 'Fel inloggningsuppgifter',
  'errors.email.not.confirmed': 'E-post ej bekräftad',
  'errors.user.not.found': 'Användaren hittades inte',
  'errors.invalid.email.password': 'Den e-post eller lösenord du angivit är felaktigt',
  'errors.missing.email.phone': 'E-post eller telefonnummer krävs',
  'errors.missing.password': 'Lösenord krävs',
  'errors.password.too.short': 'Lösenordet är för kort',
  'errors.email.taken': 'E-postadressen används redan',
  'errors.phone.taken': 'Telefonnumret används redan',
  'errors.weak.password': 'Lösenordet är för svagt',
  'errors.invalid.email': 'Ogiltigt e-postformat',
  'errors.invalid.phone': 'Ogiltigt telefonnummerformat',
  'errors.generic': 'Ett oväntat fel inträffade',
  'errors.signin': 'Inloggningsfel',
  'errors.signout': 'Utloggningsfel',
  'errors.password.update': 'Det gick inte att uppdatera lösenordet',
  'errors.missing.email': 'E-post krävs',
  'errors.invalid.recovery.link': 'Ogiltig återställningslänk',
  'errors.password.requirements': 'Lösenordet uppfyller inte kraven',
  'errors.current.password': 'Nuvarande lösenord är felaktigt',
  'errors.update.preferences': 'Det gick inte att uppdatera inställningarna',
  'errors.passwords.dont.match': 'Lösenorden matchar inte',
  'errors.invalidFileType': 'Ogiltig filtyp',
  'errors.fileTooLarge': 'Filen är för stor',
  'errors.avatarUpload': 'Det gick inte att ladda upp profilbild',
  'errors.update.status': 'Det gick inte att uppdatera status',
  'errors.authentication': 'Autentiseringsfel',
  'errors.permission': 'Åtkomst nekad',
  'errors.unexpected': 'Ett oväntat fel inträffade',
  'errors.missing_data': 'Obligatoriska data saknas',
  'errors.missing_email_or_name': 'E-post och visningsnamn krävs',
  'errors.email_failed': 'Det gick inte att skicka e-post',
  'errors.activation_email_failed': 'Det gick inte att skicka aktiverings-e-post',
  'errors.invalid_input': 'Ogiltiga inmatningsdata',
  'errors.enter_valid_number': 'Ange ett giltigt nummer',
  'errors.update_failed': 'Uppdateringen misslyckades',
  'errors.url_limits_update_failed': 'Det gick inte att uppdatera URL-gränser',
  'errors.subscription_update_failed': 'Det gick inte att uppdatera prenumerationen',
  'errors.delete_failed': 'Borttagningen misslyckades',
  'errors.user_delete_failed': 'Det gick inte att ta bort användaren',
  'errors.user_banned': 'Detta användarkonto har stängts av',
  'monitoring.url.error.approve': 'Det gick inte att godkänna URL:en',
  'monitoring.url.error.reject': 'Det gick inte att avvisa URL:en',
  'warning.admin.notification': 'Kunde inte meddela administratören om denna ändring'
};
